module.exports = __webpack_public_path__ + "static/img/company-leadership-hero.8934361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/company-leadership-hero.jpg
// module id = i5HG
// module chunks = 0